document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Scroll reveal ---------------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ---------------- Shop menu drawer (left side) ---------------- */
  var shopMenu = document.getElementById('shop-menu-drawer');

  function openShopMenu() {
    if (!shopMenu) return;
    shopMenu.classList.add('is-open');
    shopMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeShopMenu() {
    if (!shopMenu) return;
    shopMenu.classList.remove('is-open');
    shopMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Explicit triggers (rendered by header.liquid / hero.liquid)
  document.querySelectorAll('[data-shop-menu-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
      if (mobileNav) mobileNav.classList.remove('is-open');
      openShopMenu();
    });
  });

  // Safety-net: any link/button literally labeled "Catalog" or "Shop Now"
  // anywhere on the page opens the drawer too, even without the data attribute.
  document.querySelectorAll('a, button').forEach(function (el) {
    if (el.hasAttribute('data-shop-menu-open')) return; // already bound above
    var label = (el.textContent || '').trim().toLowerCase();
    if (label === 'catalog' || label === 'shop now') {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeCart();
        if (mobileNav) mobileNav.classList.remove('is-open');
        openShopMenu();
      });
    }
  });

  document.querySelectorAll('[data-shop-menu-close]').forEach(function (el) {
    el.addEventListener('click', closeShopMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeShopMenu();
  });

  // "Healthy Cat" (or any coming-soon item) reveals a message instead of navigating
  document.querySelectorAll('[data-coming-soon-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var msg = btn.nextElementSibling;
      if (msg && msg.hasAttribute('data-coming-soon-message')) {
        msg.hidden = !msg.hidden;
      }
    });
  });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  cartOpenBtns.forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); refreshCartDrawer(); }); });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeCart); });

  function renderCartItem(item) {
    return (
      '<div class="cart-drawer__item" style="display:flex;gap:14px;margin-bottom:20px;">' +
        '<img src="' + item.image + '" alt="" style="width:64px;height:80px;object-fit:cover;border-radius:2px;">' +
        '<div style="flex:1;">' +
          '<a href="' + item.url + '" style="font-size:14px;">' + item.product_title + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:12px;color:var(--color-text-muted);">' + item.variant_title + '</div>' : '') +
          '<div style="font-size:13px;color:var(--color-text-muted);margin-top:6px;">Qty ' + item.quantity + ' &middot; ' + formatMoney(item.final_line_price) + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var itemsEl = document.getElementById('cart-drawer-items');
        var subtotalEl = document.getElementById('cart-drawer-subtotal');
        var countEls = document.querySelectorAll('[data-cart-count]');

        if (itemsEl) {
          itemsEl.innerHTML = cart.items.length
            ? cart.items.map(renderCartItem).join('')
            : '<p style="color:var(--color-text-muted);">Your cart is empty.</p>';
        }
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  /* AJAX add-to-cart for any product form on the page */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding...'; submitBtn.disabled = true; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          refreshCartDrawer();
          openCart();
        })
        .catch(function () {})
        .finally(function () {
          if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
        });
    });
  });

  /* ---------------- Product page: quantity stepper ---------------- */
  document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------------- Product page: variant swatches ---------------- */
var variantSelect = document.getElementById('ProductVariantSelect');
var stockMessageEl = document.createElement('p');
stockMessageEl.id = 'variant-stock-message';
stockMessageEl.style.cssText = 'color:#c0392b;font-size:13px;margin-top:8px;display:none;';
var priceElRef = document.getElementById('ProductPrice');
if (priceElRef && priceElRef.parentNode) {
  priceElRef.parentNode.insertBefore(stockMessageEl, priceElRef.nextSibling);
}

// Disable swatches for out-of-stock variants on page load
if (window.__sinceriaVariants && variantSelect) {
  Array.from(variantSelect.options).forEach(function (opt) {
    var variant = window.__sinceriaVariants.find(function (v) { return String(v.id) === String(opt.value); });
    if (variant && variant.inventory_management && variant.inventory_quantity <= 0) {
      var swatchVal = variant.title;
      document.querySelectorAll('.swatch').forEach(function (s) {
        if (s.dataset.value === swatchVal) {
          s.disabled = true;
          s.style.opacity = '0.4';
          s.style.cursor = 'not-allowed';
          s.title = 'Out of stock';
        }
      });
    }
  });
}

document.querySelectorAll('.product-page__option').forEach(function (optionGroup) {
  optionGroup.querySelectorAll('.swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      if (swatch.disabled) return;
      optionGroup.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      swatch.classList.add('is-selected');

      if (variantSelect) {
        var selectedValues = [];
        document.querySelectorAll('.product-page__option').forEach(function (grp) {
          var sel = grp.querySelector('.swatch.is-selected');
          selectedValues.push(sel ? sel.dataset.value : null);
        });

        var matchedVariantId = null;
        Array.from(variantSelect.options).forEach(function (opt) {
          var title = opt.textContent.trim();
          if (selectedValues.every(function (v) { return v && title.indexOf(v) !== -1; })) {
            variantSelect.value = opt.value;
            matchedVariantId = opt.value;
          }
        });

        if (matchedVariantId && window.__sinceriaVariants) {
          var matchedVariant = window.__sinceriaVariants.find(function (v) { return String(v.id) === String(matchedVariantId); });
          if (matchedVariant) {
            // Update price
            var priceEl = document.getElementById('ProductPrice');
            if (priceEl) {
              priceEl.textContent = (matchedVariant.price / 100).toFixed(2).replace('.', ',') + ' €';
            }
            // Check stock and show message / disable add to cart
            var addBtn = document.querySelector('form[action^="/cart/add"] [type="submit"]');
            if (matchedVariant.inventory_management && matchedVariant.inventory_quantity <= 0) {
              stockMessageEl.textContent = 'Sorry, this bundle is out of stock.';
              stockMessageEl.style.display = 'block';
              if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
            } else {
              stockMessageEl.style.display = 'none';
              if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
            }
          }
        }
      }
    });
  });
});

  /* ---------------- Product page: thumbnail gallery ---------------- */
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.product-page__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.dataset.fullSrc;
    });
  });
});
